import {
  BankingProvidersConfigurationsDocument,
  ExpensesLegalEntitiesConnectionDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useBankingProvidersConfigurations = () => {
  const {
    data: legalEntitiesData,
    loading: loadingLegalEntities,
    error: errorLoadingLegalEntities,
  } = useQuery(ExpensesLegalEntitiesConnectionDocument)
  const legalEntities = legalEntitiesData?.companies?.legalEntitiesConnection
  const mainLegalEntityId = legalEntities?.nodes.find((node) => node.main == true)?.id

  const { data, loading, error } = useQuery(BankingProvidersConfigurationsDocument, {
    variables: { legalEntityIds: [mainLegalEntityId!] },
    skip: !mainLegalEntityId || loadingLegalEntities,
  })
  const counter = data?.banking?.providerConfigurationsConnection.totalCount
  return {
    accountProvidersAvailable: data && counter ? counter > 0 : false,
    loading: loadingLegalEntities || loading,
    error: errorLoadingLegalEntities || error,
  }
}
